<router-outlet></router-outlet>

<app-map-loader *ngIf="globalLoader.isLoading() && !isWidgetsDemoPage" [errorMessage]="globalLoader.errorMessage()" [isShown]="true"></app-map-loader>

<app-cookie-consent-banner></app-cookie-consent-banner>
